module.exports = __webpack_public_path__ + "media/images/signup-and-read-kv-5th@2x-97d1a83cfb487b972c2a3df85fe16087.png";